import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Form, Input, Button, Modal,ModalBody,ModalFooter,FormGroup,Label } from 'reactstrap';
import Switch from 'react-switch';
import { square } from 'ldrs'
square.register()    

class DormAssignResLife extends Component {

    constructor(props) {
        super(props)
        this.state = {
            permissionFlag: true,
            resLifeViewRoom: "DEFAULT",
            buildVal: "DEFAULT",
            buildList: [],
            buildName: "",
            dormOverviewData: [],
            closedFlag: false,
            allStu: [],
            fullDormAssign: [],
            manageType: true,
            loading: true,
            groupList: [],
            modalActive: false,
            editing: { pk: 0, pcid: -1, seat: "" },
            swapStu: "",
            createModal: false,
            createSelected: [
                { seat: 1, pcid: "" },
                { seat: 2, pcid: "" },
                { seat: 3, pcid: "" },
                { seat: 4, pcid: "" }
            ],
            lockModalActive: false
        }
        this.toggleSwitch = this.toggleSwitch.bind(this);
        this.apiFetch('ValidDepartments', { pagepk: "/DormAssignResLife" }, "permissionFlag")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        if (stateItem != "" && stateItem != null) {
            this.setState({
                [stateItem]: data
            })
            if (url == "ValidDepartments") {
                this.apiFetch("GetDormOverviewData", {}, "dormOverviewData")
                this.apiFetch("DormAllAssign", {}, "fullDormAssign")
                this.apiFetch("DormAssignRLGetGroups", {}, "groupList")
                
            }
            if (url == "GetDormOverviewData") {
                var buildVAR = [];
                data.map((item) => {
                    var findItem = buildVAR.find((x) => x.buildCode === item.buildCode);
                    if (!findItem) buildVAR.push(item);
                })
                var closedBOOL = false;
                if (data.length < 1) closedBOOL = true;
                this.setState({
                    buildList: buildVAR,
                    closedFlag: closedBOOL,
                    
                })
                this.apiFetch("DormAssignRLGroupCandidates", {}, "allStu")
            }
            if (url == "DormAssignRLGroupCandidates") {
                this.setState({
                    loading: false
                })
            }
        }
        if (stateItem == "") {
            return data
        }
        if (stateItem == null) {
            if (url == "ResLifeClearRoom") {
                this.setState({
                    resLifeViewRoom: "DEFAULT"
                })
            }
            if (url == "DormAssignFinalize") {
                this.setState({
                    buildVal: "DEFAULT",
                    resLifeViewRoom: "DEFAULT"
                })
            }
            if (url == "SelfAssignResLifeNewGroup") {
                this.setState({
                    createModal: false,
                    createSelected: [
                        { seat: 1, pcid: "" },
                        { seat: 2, pcid: "" },
                        { seat: 3, pcid: "" },
                        { seat: 4, pcid: "" }
                    ]
                })
            }
            if (url == "DormAssignResLifeUpdate" || url == "DormAssignFinalize" || url == "ResLifeClearRoom" || url == "SelfAssignResLifeNewGroup" || url == "SelfAssignRLLockGroups") {
                this.apiFetch("DormAllAssign", {}, "fullDormAssign")
                this.apiFetch("GetDormOverviewData", {}, "dormOverviewData")
                this.apiFetch("DormAssignRLGetGroups", {}, "groupList")
            }
        }
    }

    async clearRoom(pk, roomOptional) {
        this.apiFetch("ResLifeClearRoom", { pk: pk, roomOp: roomOptional }, null)
    }

    async finalize() {
        this.apiFetch("DormAssignFinalize", {}, null)
    }

    componentDidMount() {
        if (!this.state.modalActive && this.state.editing.pk != 0 ) {
            this.setState({
                editing: {
                    pk: 0,
                    pcid: "",
                    seat: ""
                },
                swapStu: ""
            })
        }
    }

    toggleSwitch() {
        this.setState({
            manageType: !this.state.manageType
        })
    }

    modalSwitch() {
        this.setState({
            modalActive: !this.state.modalActive
        })
    }

    clickManage(pk, pcid, num) {
        let stateAdd = { pk: pk, pcid: pcid, seat: num }
        console.log("stateAdd: ", stateAdd)
        this.setState({
            swapStu: pcid,
            modalActive: true,
            editing: stateAdd
        }, () => {

        })
        //this.modalSwitch()
    }

    shuffle(e) {
        let stateAdd = { pk: this.state.editing.pk, pcid: e.target.value, seat: this.state.editing.seat }
        this.setState({
            editing: stateAdd
        })
    }

    async updateSeat() {
        this.apiFetch("DormAssignResLifeUpdate", this.state.editing, null)
        this.setState({
            modalActive: false
        })
    }

    createModalFlip() {
        this.setState({
            createModal: !this.state.createModal
        })
    }

    addCreate(e, tgt) {
        console.log("addCreate: ", e, ", :", tgt)
        let newVal = []
        newVal.push(...this.state.createSelected)
        var index = tgt - 1
        newVal[index] = { seat: tgt, pcid: e }
        console.log("newVal: ", newVal)
        this.setState({
            createSelected: newVal
        })
    }

    async submitForm(e) {
        e.preventDefault();
        console.log("submit form")
        let toSend = {
            seat1:  this.state.createSelected[0].pcid,
            seat2: this.state.createSelected[1].pcid,
            seat3: this.state.createSelected[2].pcid,
            seat4: this.state.createSelected[3].pcid
        }
        this.apiFetch("SelfAssignResLifeNewGroup", toSend, null)
    }

    lockGroup() {
        this.apiFetch("SelfAssignRLLockGroups", {}, "")
        this.setState({ lockModalActive: false })
        alert("Locking groups now. residencelife@hood.edu will receive an email when it's done.")
    }

    async confirmRoom(pk) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //localStorage.setItem("lastFetch", moment());
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pk: pk
        }
            const response = await fetch('DormRequestConfirm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
        
        this.setState({
            resLifeViewRoom: "DEFAULT"
        })
        this.apiFetch("DormAllAssign", {}, "fullDormAssign")
        this.apiFetch("GetDormOverviewData", {}, "dormOverviewData")
    }

    overviewTable() {
        return (<div>
            <Table>
                <thead>
                    <tr>
                        <th>Room number</th>
                        <th>Room size</th>
                        <th>Room Attributes</th>
                        <th>Availability</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.dormOverviewData.filter((build) => build.buildCode == this.state.buildVal).map(item => (
                        <tr>
                            <td>{item.roomID}</td>
                            <td>{item.roomSize}</td>
                            <td>{item.roomAttr}</td>
                            <td style={{ color: (item.roomStatus.includes('Available') ? 'green' : 'red') }}>{item.roomStatus}</td>
                            {!item.roomStatus.includes('Available') ? <td><Button outline onClick={() => { this.setState({ resLifeViewRoom: item.roomID }); this.props.updateFetchTime(); }}>View</Button></td> : <td></td>}
                            {/*<td>{JSON.stringify(item.claimantList)}</td>*/}
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>)
    }

    resLifeView() {
        return (<div>
            {this.state.resLifeViewRoom == "DEFAULT" && this.buildSelect()}&emsp;&emsp;{this.state.buildVal != "DEFAULT" && <div className="rightAlignCustom"><Button onClick={() => { this.finalize(); this.props.updateFetchTime(); }}>Finalize All Confirmed Rooms In All Buildings</Button></div>}<p />
            {this.state.buildVal != "DEFAULT" && this.state.resLifeViewRoom == "DEFAULT" && this.overviewTable()}
            {this.state.buildVal != "DEFAULT" && this.state.resLifeViewRoom != "DEFAULT" && this.resLifeTableManage()}
        </div>)
    }

    buildSelect() {
        return (
            <div className="quarterOfParent">
                <Form>
                    <Input type="select" name="building_select" id="building_select" value={this.state.buildVal} onChange={(e) => {
                        this.setState({
                            buildVal: e.target.value,
                            roomVal: "DEFAULT",
                            buildName: e.target.options[e.target.selectedIndex].text,
                            stuA: "",
                            stuB: "",
                            stuC: "",
                            stuD: ""
                        }); this.props.updateFetchTime();

                    }}>
                        <option value="DEFAULT" disabled>Select Building</option>
                        {this.state.buildList.map(item => (
                            <option key={item.clientPK} value={item.buildCode}>{item.buildName}</option>
                        ))}
                    </Input>
                </Form>
            </div>
        )
    }

    resLifeTableManage() {
        let roomListProcessed = [this.state.buildName + " " + this.state.resLifeViewRoom + "A",
        this.state.buildName + " " + this.state.resLifeViewRoom + "B",
        this.state.buildName + " " + this.state.resLifeViewRoom + "C",
        this.state.buildName + " " + this.state.resLifeViewRoom + "D",]
        let thisRoomProcessed = this.state.fullDormAssign.filter(function (e) { return this.indexOf(e.room) >= 0 }, roomListProcessed)
        return (
            <div>
                <h3>Viewing: {this.state.buildName} {this.state.resLifeViewRoom}</h3>{'    '}<Button outline onClick={() => { this.setState({ resLifeViewRoom: "DEFAULT" }); this.props.updateFetchTime(); }}>Go Back</Button>
                <br />
                <br />
                <Table>
                    <thead>
                        <tr>
                            <th>Room</th>
                            <th>Student</th>
                            <th>Status</th>
                            {thisRoomProcessed[0].stuStatus != "Confirmed!" && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {thisRoomProcessed.map(item => (
                            <tr>
                                <td>{item.room}</td>
                                <td>{item.stuName}</td>
                                <td>{item.stuStatus}</td>
                                {item.isFinal == 'N' && <td><Button color="warning" outline onClick={(e) => { this.clearRoom(item.pk, item.room); this.props.updateFetchTime(); }}>Clear This Bed</Button></td>}
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <br />
                {thisRoomProcessed[0].isFinal == "N" &&
                    <div>
                        {thisRoomProcessed.length > 0 && <div className="rightAlignCustom"><Button outline color="danger" onClick={() => this.clearRoom(thisRoomProcessed[0].pk, "")}>Clear this room</Button></div>}&nbsp;
                        {thisRoomProcessed.length == thisRoomProcessed.filter((x) => x.stuStatus == "Approved").length && thisRoomProcessed.length > 0 &&
                            <div className="rightAlignCustom"><Button outline color="success" onClick={() => { this.confirmRoom(thisRoomProcessed[0].pk); this.props.updateFetchTime(); }}>Confirm This Room</Button></div>}
                    </div>}
            </div>
        )
    }

    groupView() {
        return (<div>
            <Button outline color="success" onClick={() => this.createModalFlip()}>Create New Group</Button>&ensp;&ensp;&ensp;<Button onClick={() => this.setState({lockModalActive: true}) }>Lock Groups</Button><br /> <br />
            <Modal isOpen={this.state.modalActive} toggle={this.modalSwitch.bind(this)}>
                <ModalBody>
                    <Input type="select" id="changeStu" name="changeStu" value={this.state.editing.pcid} onChange={(e) => this.shuffle(e)}>
                        <option value={this.state.swapStu}>Change to...</option>
                        <option value="">None</option>
                        {this.state.allStu.map(item => (
                            <option value={item.pcid}>{item.name} ({item.pcid})</option>
                        ))}
                    </Input><br />
                    Please note that if this seat is blanked out and the total number of members of this group falls below 3, the group will be automatically deleted.
                </ModalBody>
                <ModalFooter>{this.state.editing.pcid != this.state.swapStu && <Button color="danger" onClick={() => this.updateSeat()}>Confirm</Button>}&nbsp;<Button onClick={this.modalSwitch.bind(this)}>Close without changing</Button></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.lockModalActive }>
                <ModalBody>Are you sure?</ModalBody>
                <ModalFooter><Button color="danger" onClick={() => this.lockGroup()}>Yes</Button><Button onClick={() => this.setState({lockModalActive: false}) }>No</Button></ModalFooter>
            </Modal>
            <Modal isOpen={this.state.createModal} toggle={this.createModalFlip.bind(this) }>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Member 1</Label>
                            <Input type="select" name="member1" id="member1" value={this.state.createSelected[0].pcid}
                                onChange={(e) => this.addCreate(e.target.value, 1)}>
                                <option value="" disabled>Select...</option>
                                {this.state.allStu.map(item => (
                                    <option value={item.pcid}>{item.name} ({item.pcid})</option>
                                )) }
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Member 2</Label>
                            <Input type="select" name="member2" id="member2" value={this.state.createSelected.filter(remove => remove.seat == 2)[0].pcid}
                                onChange={(e) => this.addCreate(e.target.value, 2)}>
                                <option value="" disabled>Select...</option>
                                {this.state.allStu.map(item => (
                                    <option value={item.pcid}>{item.name} ({item.pcid})</option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Member 3</Label>
                            <Input type="select" name="member3" id="member3" value={this.state.createSelected.filter(remove => remove.seat == 3)[0].pcid}
                                onChange={(e) => this.addCreate(e.target.value, 3)}>
                                <option value="" disabled>Select...</option>
                                {this.state.allStu.map(item => (
                                    <option value={item.pcid}>{item.name} ({item.pcid})</option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Member 4</Label>
                            <Input type="select" name="member4" id="member4" value={this.state.createSelected.filter(remove => remove.seat == 4)[0].pcid}
                                onChange={(e) => this.addCreate(e.target.value, 4)}>
                                <option value="" disabled>None</option>
                                {this.state.allStu.map(item => (
                                    <option value={item.pcid}>{item.name} ({item.pcid})</option>
                                ))}
                            </Input>
                        </FormGroup>
                        {this.state.createSelected[0].pcid != "" && this.state.createSelected[1].pcid != "" && this.state.createSelected[2].pcid != "" &&
                            <Button type="submit" onClick={(e) => this.submitForm(e)}>Submit</Button>}
                    </Form>
                </ModalBody>
                <ModalFooter><Button onClick={() => {
                    this.setState({
                        createSelected: [
                            { seat: 1, pcid: "" },
                            { seat: 2, pcid: "" },
                            { seat: 3, pcid: "" },
                            { seat: 4, pcid: "" }
                        ]
                    });  this.createModalFlip.bind(this) } }>Close</Button></ModalFooter>
            </Modal>
            <Table>
                <thead>
                    <tr>
                        <th>ID Number</th>
                        <th>Member 1</th>
                        <th></th>
                        <th>Member 2</th>
                        <th></th>
                        <th>Member 3</th>
                        <th></th>
                        <th>Member 4</th>
                        <th></th>
                        <th>Leader</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.groupList.map(item => (
                        <tr>
                            <td>{item.pk}</td>
                            <td>{item.group1.name}</td>
                            <td>{<Button outline onClick={() => this.clickManage(item.pk, item.group1.pcid, 1) }>Manage...</Button>}</td>
                            <td>{item.group2.name}</td>
                            <td>{<Button outline onClick={() => this.clickManage(item.pk, item.group2.pcid, 2)}>Manage...</Button>}</td>
                            <td>{item.group3.name}</td>
                            <td>{<Button outline onClick={() => this.clickManage(item.pk, item.group3.pcid, 3)}>Manage...</Button>}</td>
                            <td>{item.group4.name}</td>
                            <td>{<Button outline onClick={() => this.clickManage(item.pk, item.group4.pcid, 4)}>Manage...</Button>}</td>
                            <td>{item.leadername}</td>
                        </tr>
                    )) }
                </tbody>
            </Table>
        </div>)
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        let pageView = <l-square
                        size = "35"
                        stroke = "5"
                        speed = "1.2"
                        color= '#132E53'
                    />
        if (!this.state.manageType && !this.state.loading) { pageView = this.resLifeView() }
        if (this.state.manageType && !this.state.loading) { pageView = this.groupView() }
        return (<div>
            
            <div className='d-flex float-right' style={{ float: 'right' }}>
                Room &nbsp;<Switch uncheckedIcon={false} checkedIcon={false} onChange={this.toggleSwitch} checked={this.state.manageType} onColor={'#888'} height={25} width={50} /> &nbsp; Group
            </div>
            <br />
            {pageView}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(DormAssignResLife);